'use client';

import { getSession } from '@/lib/nextAuth';
import { TagManager as CommonTagManager } from '@monorepo/common';

function TagManager() {
  // GTMにユーザーデータを入れる
  const setUserId = async () => {
    try {
      const session = await getSession();
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      (window as any).dataLayer = (window as any).dataLayer || [];
      // biome-ignore lint/suspicious/noExplicitAny: <explanation>
      const dataLayer = (window as any).dataLayer;

      // 未ログインはuserId=0
      dataLayer.push({
        userId: session ? session.user.id : 0,
      });
    } catch (_err) {
      // pass
    }
  };

  return <CommonTagManager gtmId={process.env.NEXT_PUBLIC_GTM_ID} onSetUserId={setUserId} />;
}

export default TagManager;
